<template>
  <div class="table-content">
    <div class="table" v-if="tableData.length">
      <table class="table-wrap">
        <tr class="tr-head">
          <td
            v-for="(title, index) in tableField"
            :key="index"
            :class="{ 'hidden-td': index == 1, 'fixed-td': index == 0 }"
          >
            <p class="tr-title">
              <span class="th-title"> {{ title.label }}</span>
            </p>
          </td>
        </tr>
        <tr v-for="row in tableData" :key="row.id">
          <td
            v-for="(item, i) in tableField"
            :key="i"
            :class="{ 'hidden-td': i == 1, 'fixed-td': i == 0 }"
          >
            <template v-if="item.prop == 'operation'">
              <slot name="opt-slot" :row="row">--</slot>
            </template>
            <template v-else>
              <slot
                name="default"
                :row="{ key: item.prop, value: row[item.prop], orgRow: row }"
              >
                <span v-if="~(item.prop + '').indexOf('time')">{{
                  row[item.prop] | formatTime
                }}</span>
                <span v-else-if="item.prop == 'position'">{{
                  row | memberType
                }}</span>
                <span v-else>{{ row[item.prop] }}</span>
              </slot>
            </template>
          </td>
        </tr>
      </table>
    </div>
    <div class="img-no-data" v-else>
      <img src="../../images/common/img_no_table.png" />
      <p>暂无数据</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    tableField: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  filters: {
    memberType(row) {
      if (row.position === 1) {
        return '室长';
      } else if (row.position === 3) {
        return '管理员';
      } else if (row.vip) {
        return '签约成员';
      } else {
        return '成员';
      }
    },
    formatTime(time) {
      const len = (time + '').length;
      const _time = time + '';
      if (len !== 10 && len !== 13) {
        return time;
      } else {
        if (~_time.indexOf('-')) return time;
        if (len === 10) time *= 1000;
        const t = new Date(time);
        return (
          t.getFullYear() +
          '-' +
          (101 + t.getMonth() + '').slice(-2) +
          '-' +
          (100 + t.getDate() + '').slice(-2)
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.table-wrap {
  font-size: 24px;
  width: 100%;
  border: 1px solid #d9d9d9;
  tr:nth-child(odd) {
    background: #fafafa;
  }
  tr:nth-child(even) {
    background: #fff;
  }

  td {
    display: inline-block;
    width: 200px;
    line-height: 88px;
    text-align: center;
    position: relative;
  }
  tr {
    td:nth-child(1) {
      padding-left: 10px;
      line-height: 88px;
      position: absolute;
      border-left: 1px solid#d9d9d9;
      margin-left: -2px;
    }
    .hidden-td {
      padding-left: 140px;
    }
  }
  tr:nth-child(odd) {
    .fixed-td {
      background: #fafafa;
    }
  }
  tr:nth-child(even) {
    .fixed-td {
      background: #fff;
    }
  }
  .fixed-td {
    z-index: 100;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tr-head {
    border-bottom: 1px solid #d9d9d9;
    .tr-title {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #8c8c8c;
      img {
        display: block;
        width: 20px;
        height: 20px;
        margin-left: 5px;
        margin-top: -5px;
      }
    }
  }

  .explain-txt {
    position: absolute;
    top: 90px;
    background: rgba(0, 0, 0, 0.6);
    white-space: pre-wrap;
    text-align: justify;
    color: #fff;
    padding: 5px;
    line-height: 1.5;
    font-size: 24px;
  }
  .show-pop {
    display: block;
  }
  .hide-pop {
    display: none;
  }
  .btn-detail {
    color: #2b6ddf;
    text-decoration: underline;
    font-weight: 600;
  }
}

.table {
  width: 100%;
  margin-top: 23px;
  white-space: nowrap;
  overflow-x: scroll;
  margin-bottom: 20px;
}

.img-no-data {
  margin-top: 50px;
  text-align: center;
  img {
    margin: 0 auto;
    display: block;
    width: 192px;
    height: 152px;
  }
  p {
    margin-top: 20px;
  }
}
</style>
